import * as React from 'react';
import {
    TransitionTypeChangedEvent,
    TransitionTypeEvent
} from '../../../services/transitionType/TransitionTypeController';
import { ProfileInjectorProperties } from '../ProfileInjector';
import { MainTransitionTypeController } from './transitionTypeControllerInstance';
import { TransitionType } from '../../../utils/types';

interface TransitionTypeInjectorProperties extends ProfileInjectorProperties {}

interface TransitionTypeInjectorState {
    transitionType: TransitionType;
}

type ReactComponentConstructor<P, S> = new(props: P) => React.Component<P, S>;
export function injectTransitionTypeHandlers<P extends TransitionTypeInjectorProperties>(
    component: React.ComponentType<P>
): ReactComponentConstructor<P, TransitionTypeInjectorState> {
    const Component = component;

    return class TransitionTypeInjector extends React.Component<P, TransitionTypeInjectorState> {

        constructor(props: P) {
            super(props);

            this.state = {
                transitionType: this.getTransitionType()
            };
        }

        componentDidMount() {
            this.registerViewChangedListener();
            this.updateTransitionType();
        }

        render() {
            const propagatedProperties: P = { ...this.props };
            return <Component {...propagatedProperties} transitionType={this.state.transitionType} />;
        }

        private updateTransitionType(): void {
            const transitionType = this.getTransitionType();
            this.setState({ transitionType });
        }

        private getTransitionType(): TransitionType {
            const view = MainTransitionTypeController.ensureInstance(this.props.transitionType).getView();
            return view;
        }

        private registerViewChangedListener() {
            document.addEventListener(TransitionTypeEvent.TypeChanged, (event: TransitionTypeChangedEvent) => {
                const transitionType = event.detail.transitionType;
                this.setState({ transitionType });
            });
        }
    };
}


// WEBPACK FOOTER //
// ./src/webportal/components/hocs/transitionType/TransitionTypeInjector.tsx